import React, { Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { Hero2 } from "../components";

const handleClick = (e) => {
  e.preventDefault(); // Verhindert den Standard-Link-Verhalten

  // Cookie "myCookieConsent" löschen
  document.cookie = "myCookieConsent=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  
  // Seite neu laden
  window.location.reload();   
};

const PLC = () => (
  <Fragment>
    <Hero2 />
    <hr />
    <div className="row">
      <div className="col-md-6 mb-4 text-center">
        <h6 className="mb-3">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="/privacy-policy"
          >
            <FontAwesomeIcon icon={faLink} className="mr-2" />
            Datenschutzerklärung
          </a>
        </h6>
        <p>
          Unsere Datenschutzerklärung inkl. den Informationen zu den Cookies findest Du hier. Bei Fragen oder Anliegen kannst Du uns jederzeit gerne unter info@mydeserve.ch erreichen.
        </p>
      </div>
      <div className="col-md-6 mb-4 text-center">
        <h6 className="mb-3">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="#"
            onClick={handleClick}
          >
            <FontAwesomeIcon icon={faLink} className="mr-2" />
            Cookie-Einstellungen vornehmen
          </a>
        </h6>
        <p>
          Du kannst Deine Cookie-Einstellungen jederzeit anpassen.
        </p>
      </div>
    </div>
  </Fragment>
);

export default PLC;
